import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Input } from '../../primitives/Input/Input.js';
import styles from './PriceInput.module.css';
/** Un montant saisi : chiffres, séparateur `.` ou `,`, deux décimales au plus. */
const SAISIE_VALIDE = /^\d*(?:[.,]\d{0,2})?$/;
const SAISIE_SIGNEE = /^-?\d*(?:[.,]\d{0,2})?$/;
function formater(cents, lang) {
    if (cents === null)
        return '';
    const texte = (cents / 100).toFixed(2);
    return lang === 'fr' ? texte.replace('.', ',') : texte;
}
function lireCentimes(texte) {
    const net = texte.replace(/\s/g, '');
    if (net === '' || net === '-' || net === '.' || net === ',' || net === '-.' || net === '-,')
        return null;
    return Math.round(Number(net.replace(',', '.')) * 100);
}
/**
 * Saisie de prix : affiche des unités, émet des centimes (2.4, mono
 * `tabular-nums`). Accepte la virgule comme le point décimal, refuse le signe
 * moins sauf `allowNegative`, les lettres, et — en mode `optional` — distingue un champ vide
 * (`null`, « pas de prix ») d'un vrai zéro. Texte libre plutôt que
 * `type="number"` : ce dernier impose le séparateur du navigateur et efface
 * ce que l'on tape à moitié.
 */
export function PriceInput({ cents, onCentsChange, optional = false, lang = 'fr', currency = 'EUR', allowNegative = false, className, onBlur, ...rest }) {
    const [texte, setTexte] = useState(() => formater(cents, lang));
    const [centsVu, setCentsVu] = useState(cents);
    // Une valeur changée par le parent (réinitialisation, autre onglet) prime
    // sur le texte en cours, sauf quand elle ne fait que refléter la saisie.
    if (cents !== centsVu) {
        setCentsVu(cents);
        if (cents !== lireCentimes(texte) && !(cents === 0 && !optional && texte === '')) {
            setTexte(formater(cents, lang));
        }
    }
    const handleChange = (event) => {
        const brut = event.target.value;
        if (!(allowNegative ? SAISIE_SIGNEE : SAISIE_VALIDE).test(brut.replace(/\s/g, '')))
            return;
        setTexte(brut);
        const lu = lireCentimes(brut);
        if (optional)
            onCentsChange(lu);
        else
            onCentsChange(lu ?? 0);
    };
    const handleBlur = (event) => {
        const lu = lireCentimes(texte);
        setTexte(formater(lu === null && !optional ? 0 : lu, lang));
        onBlur?.(event);
    };
    const classes = [styles.wrapper, className].filter(Boolean).join(' ');
    return (_jsxs("span", { className: classes, children: [_jsx(Input, { className: styles.input, mono: true, type: "text", inputMode: "decimal", autoComplete: "off", lang: lang, value: texte, onChange: handleChange, onBlur: handleBlur, ...rest }), _jsx("span", { className: styles.suffix, "aria-hidden": "true", children: currency === 'EUR' ? '€' : currency })] }));
}
//# sourceMappingURL=PriceInput.js.map